'use client'

import { TextLink } from '@/General/TextLink'
import Link from 'next/link'
import { tracking } from '@/tracking'

export type TopSellerItem = {
  id?: number | null
  name?: string | null
  url?: string | null
  imageUrl?: string | null
  isOnSale?: boolean
}

export function BestSellingMagicClient({
  items,
  headingId,
  title = 'Our Best Selling Magic Tricks',
  trackingEvent = 'Clicked top seller',
}: {
  items: TopSellerItem[]
  headingId?: string
  title?: string
  trackingEvent?: string
}) {
  const onClick = (item: TopSellerItem, rank: number) => {
    tracking.track(trackingEvent, {
      'Top sellers product ID': item.id ?? '',
      'Top sellers product name': item.name ?? '',
      'Top sellers rank': rank,
    })
  }

  return (
    <div className="rounded-lg bg-gray-100 p-4 md:p-3">
      <h2
        id={headingId}
        className="mb-4 border-y-2 border-vi-gray py-2 text-center text-lg font-medium md:text-2xl"
      >
        {title}
      </h2>
      <ol className="list-inside list-decimal space-y-3 pl-1">
        {items.map((topSeller, index) => {
          const rank = index + 1
          return (
            <li
              key={topSeller.id || index}
              className="flex items-start"
              data-productid={topSeller.id}
              data-productname={topSeller.name}
              data-rank={rank}
            >
              {topSeller.url && topSeller.imageUrl && (
                <Link
                  href={topSeller.url}
                  className="mr-2 shrink-0"
                  onClick={() => onClick(topSeller, rank)}
                >
                  <img
                    src={`${topSeller.imageUrl}?format=auto&w=35&dpr=2`}
                    alt={topSeller.name || ''}
                    className="h-12 w-9 rounded-md object-cover"
                    loading="lazy"
                    fetchPriority="low"
                  />
                </Link>
              )}
              <div className="min-w-0 flex-1">
                {rank}.{' '}
                {topSeller.url ? (
                  <TextLink
                    href={topSeller.url}
                    className="no-underline! hover:underline!"
                    onClick={() => onClick(topSeller, rank)}
                  >
                    {topSeller.name}
                  </TextLink>
                ) : (
                  <span>{topSeller.name}</span>
                )}
                {topSeller.isOnSale && (
                  <span className="ml-2 inline-block rounded bg-green-600 px-1.5 py-0.5 text-[10px] font-semibold tracking-wide text-white">
                    SALE
                  </span>
                )}
              </div>
            </li>
          )
        })}
      </ol>
    </div>
  )
}
